import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import appSlice from 'common/store/appSlice';
import authSlice from 'features/account/authSlice';
import giftingSlice from 'features/gifting/giftingSlice';
import { rtkQueryErrorHandler } from 'common/utils/rtkErrorHandler';
import { baseApi } from 'common/store/baseApi';

export const rootReducer = combineReducers({
  app: appSlice,
  auth: authSlice,
  gifting: giftingSlice,
  [baseApi.reducerPath]: baseApi.reducer,
});

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
  blacklist: [baseApi.reducerPath],
};

export const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      ignoreActions: true,
      ignoreState: true,
    },
  }).concat(baseApi.middleware, rtkQueryErrorHandler),
});

export const persistor = persistStore(store);
